import React from 'react'
import PropTypes from 'prop-types'

import ContentHolder from '../../ui/ContentHolder'
import BuyerProfiles from './BuyerProfiles'
import Comparables from './Comparables'
import KeyFeatures from './KeyFeatures'
import SaleMethod from './SaleMethod'
import styles from './styles.scss'

const PropertyDetails = (props) => {
  const { brand, campaign, campaignSaleMethod } = props

  return (
    <div className={styles.root}>
      <ContentHolder>
        <h2>About Your Property</h2>

        <KeyFeatures campaign={campaign} />

        <BuyerProfiles campaign={campaign} />

        <Comparables brand={brand} campaign={campaign} />

        <SaleMethod campaignSaleMethod={campaignSaleMethod} />
      </ContentHolder>
    </div>
  )
}

PropertyDetails.propTypes = {
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  campaignSaleMethod: PropTypes.object.isRequired,
}

export default PropertyDetails
